
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tresty",
      function () {
        return require("private-next-pages/tresty/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tresty"])
      });
    }
  